<div class="dialog-header">
  <div class="header-title">
		<span style="font-size: 120%;">
			<span style="margin-right: 0.5em;">{{payPeriod.user.name}}</span>
			<span>{{dateString}}</span>
		</span>
  </div>

  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <ng-container *ngIf="!sheetLoading">
    <div class="record-button-bar">
      <button mat-button class="add-icon" (click)="addSheet()">
        <mat-icon>add</mat-icon>
        <div class="button-label" *ngIf="!isMobile">
          Create Record
        </div>
      </button>

      <div class="dev-block" *ngIf="currentUser.adminRole">
        <p-dropdown class="pp-dropdown" [options]="days" [(ngModel)]="selectedDay" placeholder="Day"
                    optionLabel="date">
          <ng-template let-item pTemplate="selectedItem">
            {{item?.date | date:'MMM d'}}
          </ng-template>
          <ng-template let-item pTemplate="item">
            {{item?.date | date:'MMM d'}}
          </ng-template>
        </p-dropdown>

        <input class="fill-input" matInput [(ngModel)]="hoursToFill" placeholder="Hours" type="number"
               autocomplete="off" [min]="0" [max]="160">
        <div class="fill-button" (click)="fillHours()">
          <button mat-button
                  [disabled]="!selectedDay || !hoursToFill || (hoursToFill <= 0 || hoursToFill > 24)"
                  [ngClass]="{'disabled-header-button': !selectedDay || !hoursToFill || (hoursToFill <= 0 || hoursToFill > 24)}">
            Fill
          </button>
        </div>
      </div>

      <div class="flex-box" *ngIf="!isMobile">
      </div>

      <div class="print-block" *ngIf="!isMobile">
        <button mat-button (click)="openPdfPeriod()" class="print-button">
          <mat-icon class="print-icon">print</mat-icon>
        </button>

      </div>
      <div class="approve-button-block" *ngIf="!isMobile">
        <button mat-button (click)="approve()" class="approve-button"
                [ngClass]="{'approved': payPeriod.approved}">
          <span *ngIf="!payPeriod.approved">Approve</span>
          <span *ngIf="payPeriod.approved">Unapprove</span>
        </button>
      </div>
    </div>

    <app-additional-report-header [payPeriod]="payPeriod"></app-additional-report-header>

    <app-additional-report-info [payPeriod]="payPeriod" [reportCard]="reportCard" [editions]="reportCard.editions"></app-additional-report-info>

    <p-table id="primeTable" [value]="reportCard.weeks" [rowTrackBy]="trackEntityById">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 8em;">Date</th>
          <th style="width: 7em;">Day</th>
          <th style="width: 8em;" *ngIf="!isMobile">In</th>
          <th style="width: 8em;" *ngIf="!isMobile">Out</th>
          <th style="width: 7em;" *ngIf="!isMobile">Hours</th>
          <th style="width: 10em;">Day Total</th>
          <th style="width: 11em;" *ngIf="!isMobile">Week Total</th>
          <th *ngIf="!isMobile">Job</th>
          <th *ngIf="!isMobile">SRT</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-week>
        <ng-container>

          <tr class="week-bar">
            <td colspan="9">Week {{getWeekIndex(week)}}</td>
          </tr>
          <ng-container *ngFor="let day of week.days; trackBy: trackEntityById">

            <tr *ngFor="let record of day.records; trackBy: trackEntityById" class="table-card"
                (click)="openSheetDialog(record)">
              <td>{{record.start | date: 'M/d/yy'}}</td>
              <td>{{record.start | date: 'EEE'}}</td>
              <td *ngIf="record.punchInOutsideShop && !isMobile">
                <div class="marker-block">
                  <span style="flex: 1;">{{record.start | date: 'shortTime'}}</span>
                  <i class="pi pi-map-marker"
                     style="font-size: 100%; width: 1.25em; text-align: center; font-weight: bold;"
                     (click)="openPunchInMapWithMarker(record, $event)"></i>
                </div>
              </td>
              <td *ngIf="!record.punchInOutsideShop && !isMobile">{{record.start | date: 'shortTime'}}</td>

              <td *ngIf="record.punchOutOutsideShop && !isMobile">
                <div class="marker-block">
                  <span style="flex: 1;">{{record.finish | date: 'shortTime'}}</span>
                  <i class="pi pi-map-marker"
                     style="font-size: 100%; width: 1.25em; text-align: center; font-weight: bold;"
                     (click)="openPunchOutMapWithMarker(record, $event)"></i>
                </div>
              </td>
              <td *ngIf="!record.punchOutOutsideShop && !isMobile">{{record.finish | date: 'shortTime'}}</td>

              <td *ngIf="!isMobile">{{(record.duration / 60) | number:'1.2-2'}}</td>
              <td>{{(record.dayTotal / 60) | number:'1.2-2'}}</td>
              <td *ngIf="!isMobile">{{(record.weekTotal / 60) | number:'1.2-2'}}</td>

              <ng-container *ngIf="!isMobile">
                <td *ngIf="record.type === 'WORK'">{{record.projectName}}</td>
                <td *ngIf="record.type === 'UNPAID_BREAK'" class="break-td lunch-td"><span>Lunch Break</span></td>
                <td *ngIf="record.type === 'PAID_BREAK'" class="break-td rest-td"><span>Rest Break</span></td>
                <td *ngIf="record.type === 'VACATION'" class="break-td vacation-td"><span>Vacation</span></td>
                <td *ngIf="record.type === 'UNPAID_VACATION'" class="break-td unpaid-vacation-td"><span>Unpaid Vacation</span></td>
                <td *ngIf="record.type === 'SICK_HOURS'" class="break-td sick-td"><span>Sick</span></td>
              </ng-container>

              <td *ngIf="!isMobile">
                <span *ngIf="record.closeStatus === 'Modified via SRT'">
			            <i class="pi pi-check" *ngIf="isMobile"></i>
			            <span *ngIf="!isMobile">Modified via SRT</span>
                </span>
                <span *ngIf="record.closeStatus === 'Closed by system'">
			            <i class="pi pi-exclamation-triangle" *ngIf="isMobile"></i>
			            <span *ngIf="!isMobile">Closed by system</span>
                </span>
              </td>
            </tr>
            <tr class="day-separater">
              <td colspan="9"></td>
            </tr>
            <tr class="day-empty-separater">
              <td colspan="9"></td>
            </tr>
          </ng-container>
        </ng-container>

      </ng-template>
    </p-table>

  </ng-container>


  <div class="spinner-box" *ngIf="sheetLoading">
    <mat-spinner class="spinner"></mat-spinner>
  </div>

</div>
